import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { FilterCombobox } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/FilterCombobox';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Abschnitt = { value: string; name: string };

export function LehrjahrFilter({ view }: { view: View }) {
  const { t } = useTranslation();
  const { store } = useRotationsplanFeatureContext();
  const {
    data: { abschnitte },
    ui: {
      kalender: {
        filter: { abschnitte: kalenderFilter },
      },
      uebersicht: {
        filter: { abschnitte: uebersichtFilter },
      },
    },
  } = store;
  const [selectedAbschnitte, setSelectedAbschnitte] = useState<Abschnitt[]>(
    view === 'planung' ? kalenderFilter : uebersichtFilter,
  );

  const options = abschnitte.map((abschnitt) => ({
    value: abschnitt.value,
    label: abschnitt.name,
  }));

  function applySelection(newAbschnitte: Abschnitt[]) {
    setSelectedAbschnitte(newAbschnitte);
    if (view === 'planung') {
      store.setKalenderGliederungFilter(newAbschnitte);
    } else {
      store.setUebersichtGliederungFilter(newAbschnitte);
    }
  }

  return (
    <FilterCombobox
      label={t('domain.mitarbeiter.rotationsplan.filter.lehrjahr')}
      options={options}
      value={selectedAbschnitte.map((abschnitt) => abschnitt.value)}
      onValueChange={(values) =>
        applySelection(
          abschnitte.filter((abschnitt) => values.includes(abschnitt.value)),
        )
      }
      onClear={() => applySelection([])}
    />
  );
}
